// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectIdResponse,
    ObjectNoResponse,
    ProviderEvidence,
    ProviderEvidenceType,
    ProviderMissingEvidence,
    SupportCreateEvidencePayload,
    SupportCreateEvidenceTypePayload,
    SupportEvidence,
    SupportEvidenceType,
    SupportMissingEvidence,
    SupportUpdateEvidencePayload,
    SupportUpdateEvidenceStatusToDeniedPayload,
    SupportUpdateEvidenceTypePayload,
    SupportCreateEvidencePayloadToJSON,
    SupportCreateEvidenceTypePayloadToJSON,
    SupportUpdateEvidencePayloadToJSON,
    SupportUpdateEvidenceStatusToDeniedPayloadToJSON,
    SupportUpdateEvidenceTypePayloadToJSON,
    ObjectIdResponseFromJSON,
    ObjectNoResponseFromJSON,
    ProviderEvidenceFromJSON,
    ProviderEvidenceTypeFromJSON,
    ProviderMissingEvidenceFromJSON,
    SupportEvidenceFromJSON,
    SupportEvidenceTypeFromJSON,
    SupportMissingEvidenceFromJSON,
} from '../models';

export interface GetProviderEvidenceRequest {
    id: string;
}

export interface GetProviderEvidenceListRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetProviderEvidenceListOrderEnum>;
    filterCreated?: Array<string>;
    filterUpdated?: Array<string>;
    sort?: Array<GetProviderEvidenceListSortEnum>;
    filterStatus?: Array<string>;
    filterExperimentId?: Array<string>;
    filterPrimaryPayerId?: Array<string>;
    filterBillingProviderId?: Array<string>;
    filterRenderingProviderId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterExpired?: Array<string>;
}

export interface GetProviderEvidenceMissingListRequest {
    limit?: number;
    offset?: number;
    order?: Array<GetProviderEvidenceMissingListOrderEnum>;
    sort?: Array<GetProviderEvidenceMissingListSortEnum>;
    filterExperimentId?: Array<string>;
}

export interface GetProviderEvidenceTypeRequest {
    id: string;
}

export interface GetProviderEvidenceTypeListRequest {
    limit?: number;
    offset?: number;
    order?: Array<GetProviderEvidenceTypeListOrderEnum>;
    sort?: Array<GetProviderEvidenceTypeListSortEnum>;
}

export interface GetSupportEvidenceRequest {
    id: string;
}

export interface GetSupportEvidenceListRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<GetSupportEvidenceListOrderEnum>;
    filterCreated?: Array<string>;
    filterUpdated?: Array<string>;
    sort?: Array<GetSupportEvidenceListSortEnum>;
    filterStatus?: Array<string>;
    filterExperimentId?: Array<string>;
    filterPrimaryPayerId?: Array<string>;
    filterBillingProviderId?: Array<string>;
    filterRenderingProviderId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterExpired?: Array<string>;
}

export interface GetSupportEvidenceMissingListRequest {
    limit?: number;
    offset?: number;
    order?: Array<GetSupportEvidenceMissingListOrderEnum>;
    sort?: Array<GetSupportEvidenceMissingListSortEnum>;
    filterExperimentId?: Array<string>;
}

export interface GetSupportEvidenceTypeRequest {
    id: string;
}

export interface GetSupportEvidenceTypeListRequest {
    limit?: number;
    offset?: number;
    order?: Array<GetSupportEvidenceTypeListOrderEnum>;
    sort?: Array<GetSupportEvidenceTypeListSortEnum>;
    filterActive?: string;
}

export interface PostSupportEvidenceRequest {
    supportCreateEvidencePayload: SupportCreateEvidencePayload;
}

export interface PostSupportEvidenceTypeRequest {
    supportCreateEvidenceTypePayload: SupportCreateEvidenceTypePayload;
}

export interface PostSupportEvidenceTypeDisableRequest {
    id: string;
}

export interface PutSupportEvidenceRequest {
    id: string;
    supportUpdateEvidencePayload: SupportUpdateEvidencePayload;
}

export interface PutSupportEvidenceApproveRequest {
    id: string;
}

export interface PutSupportEvidenceDenyRequest {
    id: string;
    supportUpdateEvidenceStatusToDeniedPayload: SupportUpdateEvidenceStatusToDeniedPayload;
}

export interface PutSupportEvidenceTypeRequest {
    id: string;
    supportUpdateEvidenceTypePayload: SupportUpdateEvidenceTypePayload;
}

export interface RefreshSupportEvidenceRequest {
    id: string;
}

/**
 * no description
 */
export class EvidenceApi extends runtime.BaseAPI {

    /**
     * Get evidence
     * Get evidence
     */
    async getProviderEvidenceRaw(requestParameters: GetProviderEvidenceRequest): Promise<runtime.ApiResponse<ProviderEvidence>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderEvidence.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:evidence"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/evidence/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderEvidenceFromJSON(jsonValue));
    }

    /**
     * Get evidence
     * Get evidence
     */
    async getProviderEvidence(requestParameters: GetProviderEvidenceRequest): Promise<ProviderEvidence> {
        const response = await this.getProviderEvidenceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of evidence
     * Get a list of evidence
     */
    async getProviderEvidenceListRaw(requestParameters: GetProviderEvidenceListRequest): Promise<runtime.ApiResponse<Array<ProviderEvidence>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterExperimentId) {
            queryParameters['filterExperimentId'] = requestParameters.filterExperimentId;
        }

        if (requestParameters.filterPrimaryPayerId) {
            queryParameters['filterPrimaryPayerId'] = requestParameters.filterPrimaryPayerId;
        }

        if (requestParameters.filterBillingProviderId) {
            queryParameters['filterBillingProviderId'] = requestParameters.filterBillingProviderId;
        }

        if (requestParameters.filterRenderingProviderId) {
            queryParameters['filterRenderingProviderId'] = requestParameters.filterRenderingProviderId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterExpired) {
            queryParameters['filterExpired'] = requestParameters.filterExpired;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:evidence"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/evidence`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderEvidenceFromJSON));
    }

    /**
     * Get a list of evidence
     * Get a list of evidence
     */
    async getProviderEvidenceList(requestParameters: GetProviderEvidenceListRequest): Promise<Array<ProviderEvidence>> {
        const response = await this.getProviderEvidenceListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of evidence that is missing from at least 1 experiment.
     * Get a list of evidence that is missing from at least 1 experiment.
     */
    async getProviderEvidenceMissingListRaw(requestParameters: GetProviderEvidenceMissingListRequest): Promise<runtime.ApiResponse<Array<ProviderMissingEvidence>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterExperimentId) {
            queryParameters['filterExperimentId'] = requestParameters.filterExperimentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:evidence"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/evidence/missing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderMissingEvidenceFromJSON));
    }

    /**
     * Get a list of evidence that is missing from at least 1 experiment.
     * Get a list of evidence that is missing from at least 1 experiment.
     */
    async getProviderEvidenceMissingList(requestParameters: GetProviderEvidenceMissingListRequest): Promise<Array<ProviderMissingEvidence>> {
        const response = await this.getProviderEvidenceMissingListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an evidence type
     * Get an evidence type
     */
    async getProviderEvidenceTypeRaw(requestParameters: GetProviderEvidenceTypeRequest): Promise<runtime.ApiResponse<ProviderEvidenceType>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderEvidenceType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:evidence"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/evidence/type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderEvidenceTypeFromJSON(jsonValue));
    }

    /**
     * Get an evidence type
     * Get an evidence type
     */
    async getProviderEvidenceType(requestParameters: GetProviderEvidenceTypeRequest): Promise<ProviderEvidenceType> {
        const response = await this.getProviderEvidenceTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * List experiment evidence types
     * List experiment evidence types
     */
    async getProviderEvidenceTypeListRaw(requestParameters: GetProviderEvidenceTypeListRequest): Promise<runtime.ApiResponse<Array<ProviderEvidenceType>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:evidence"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/evidence/type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderEvidenceTypeFromJSON));
    }

    /**
     * List experiment evidence types
     * List experiment evidence types
     */
    async getProviderEvidenceTypeList(requestParameters: GetProviderEvidenceTypeListRequest): Promise<Array<ProviderEvidenceType>> {
        const response = await this.getProviderEvidenceTypeListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get evidence
     * Get evidence
     */
    async getSupportEvidenceRaw(requestParameters: GetSupportEvidenceRequest): Promise<runtime.ApiResponse<SupportEvidence>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEvidence.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEvidenceFromJSON(jsonValue));
    }

    /**
     * Get evidence
     * Get evidence
     */
    async getSupportEvidence(requestParameters: GetSupportEvidenceRequest): Promise<SupportEvidence> {
        const response = await this.getSupportEvidenceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of evidence
     * Get a list of evidence
     */
    async getSupportEvidenceListRaw(requestParameters: GetSupportEvidenceListRequest): Promise<runtime.ApiResponse<Array<SupportEvidence>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterUpdated) {
            queryParameters['filterUpdated'] = requestParameters.filterUpdated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterStatus) {
            queryParameters['filterStatus'] = requestParameters.filterStatus;
        }

        if (requestParameters.filterExperimentId) {
            queryParameters['filterExperimentId'] = requestParameters.filterExperimentId;
        }

        if (requestParameters.filterPrimaryPayerId) {
            queryParameters['filterPrimaryPayerId'] = requestParameters.filterPrimaryPayerId;
        }

        if (requestParameters.filterBillingProviderId) {
            queryParameters['filterBillingProviderId'] = requestParameters.filterBillingProviderId;
        }

        if (requestParameters.filterRenderingProviderId) {
            queryParameters['filterRenderingProviderId'] = requestParameters.filterRenderingProviderId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterExpired) {
            queryParameters['filterExpired'] = requestParameters.filterExpired;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportEvidenceFromJSON));
    }

    /**
     * Get a list of evidence
     * Get a list of evidence
     */
    async getSupportEvidenceList(requestParameters: GetSupportEvidenceListRequest): Promise<Array<SupportEvidence>> {
        const response = await this.getSupportEvidenceListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of evidence that is missing from at least 1 experiment.
     * Get a list of evidence that is missing from at least 1 experiment.
     */
    async getSupportEvidenceMissingListRaw(requestParameters: GetSupportEvidenceMissingListRequest): Promise<runtime.ApiResponse<Array<SupportMissingEvidence>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterExperimentId) {
            queryParameters['filterExperimentId'] = requestParameters.filterExperimentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/missing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportMissingEvidenceFromJSON));
    }

    /**
     * Get a list of evidence that is missing from at least 1 experiment.
     * Get a list of evidence that is missing from at least 1 experiment.
     */
    async getSupportEvidenceMissingList(requestParameters: GetSupportEvidenceMissingListRequest): Promise<Array<SupportMissingEvidence>> {
        const response = await this.getSupportEvidenceMissingListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get an evidence type
     * Get an evidence type
     */
    async getSupportEvidenceTypeRaw(requestParameters: GetSupportEvidenceTypeRequest): Promise<runtime.ApiResponse<SupportEvidenceType>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEvidenceType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEvidenceTypeFromJSON(jsonValue));
    }

    /**
     * Get an evidence type
     * Get an evidence type
     */
    async getSupportEvidenceType(requestParameters: GetSupportEvidenceTypeRequest): Promise<SupportEvidenceType> {
        const response = await this.getSupportEvidenceTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * List experiment evidence types
     * List experiment evidence types
     */
    async getSupportEvidenceTypeListRaw(requestParameters: GetSupportEvidenceTypeListRequest): Promise<runtime.ApiResponse<Array<SupportEvidenceType>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportEvidenceTypeFromJSON));
    }

    /**
     * List experiment evidence types
     * List experiment evidence types
     */
    async getSupportEvidenceTypeList(requestParameters: GetSupportEvidenceTypeListRequest): Promise<Array<SupportEvidenceType>> {
        const response = await this.getSupportEvidenceTypeListRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create evidence
     * Create evidence
     */
    async postSupportEvidenceRaw(requestParameters: PostSupportEvidenceRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['supportCreateEvidencePayload'] === null || requestParameters['supportCreateEvidencePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateEvidencePayload','Required parameter requestParameters.supportCreateEvidencePayload was null or undefined when calling postSupportEvidence.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateEvidencePayloadToJSON(requestParameters['supportCreateEvidencePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Create evidence
     * Create evidence
     */
    async postSupportEvidence(requestParameters: PostSupportEvidenceRequest): Promise<ObjectIdResponse> {
        const response = await this.postSupportEvidenceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create an experiment evidence type
     * Create an experiment evidence type
     */
    async postSupportEvidenceTypeRaw(requestParameters: PostSupportEvidenceTypeRequest): Promise<runtime.ApiResponse<ObjectIdResponse>> {
        if (requestParameters['supportCreateEvidenceTypePayload'] === null || requestParameters['supportCreateEvidenceTypePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateEvidenceTypePayload','Required parameter requestParameters.supportCreateEvidenceTypePayload was null or undefined when calling postSupportEvidenceType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/type`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateEvidenceTypePayloadToJSON(requestParameters['supportCreateEvidenceTypePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectIdResponseFromJSON(jsonValue));
    }

    /**
     * Create an experiment evidence type
     * Create an experiment evidence type
     */
    async postSupportEvidenceType(requestParameters: PostSupportEvidenceTypeRequest): Promise<ObjectIdResponse> {
        const response = await this.postSupportEvidenceTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an evidence type
     * Disable an evidence type
     */
    async postSupportEvidenceTypeDisableRaw(requestParameters: PostSupportEvidenceTypeDisableRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportEvidenceTypeDisable.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/type/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an evidence type
     * Disable an evidence type
     */
    async postSupportEvidenceTypeDisable(requestParameters: PostSupportEvidenceTypeDisableRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportEvidenceTypeDisableRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update evidence
     * Update evidence
     */
    async putSupportEvidenceRaw(requestParameters: PutSupportEvidenceRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportEvidence.');
        }

        if (requestParameters['supportUpdateEvidencePayload'] === null || requestParameters['supportUpdateEvidencePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateEvidencePayload','Required parameter requestParameters.supportUpdateEvidencePayload was null or undefined when calling putSupportEvidence.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateEvidencePayloadToJSON(requestParameters['supportUpdateEvidencePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update evidence
     * Update evidence
     */
    async putSupportEvidence(requestParameters: PutSupportEvidenceRequest): Promise<ObjectNoResponse> {
        const response = await this.putSupportEvidenceRaw(requestParameters);
        return await response.value();
    }

    /**
     * Change the evidence status to approve
     * Change the evidence status to approve
     */
    async putSupportEvidenceApproveRaw(requestParameters: PutSupportEvidenceApproveRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportEvidenceApprove.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Change the evidence status to approve
     * Change the evidence status to approve
     */
    async putSupportEvidenceApprove(requestParameters: PutSupportEvidenceApproveRequest): Promise<ObjectNoResponse> {
        const response = await this.putSupportEvidenceApproveRaw(requestParameters);
        return await response.value();
    }

    /**
     * Change the evidence status to denied
     * Change the evidence status to denied
     */
    async putSupportEvidenceDenyRaw(requestParameters: PutSupportEvidenceDenyRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportEvidenceDeny.');
        }

        if (requestParameters['supportUpdateEvidenceStatusToDeniedPayload'] === null || requestParameters['supportUpdateEvidenceStatusToDeniedPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateEvidenceStatusToDeniedPayload','Required parameter requestParameters.supportUpdateEvidenceStatusToDeniedPayload was null or undefined when calling putSupportEvidenceDeny.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/{id}/deny`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateEvidenceStatusToDeniedPayloadToJSON(requestParameters['supportUpdateEvidenceStatusToDeniedPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Change the evidence status to denied
     * Change the evidence status to denied
     */
    async putSupportEvidenceDeny(requestParameters: PutSupportEvidenceDenyRequest): Promise<ObjectNoResponse> {
        const response = await this.putSupportEvidenceDenyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update evidence type
     * Update evidence type
     */
    async putSupportEvidenceTypeRaw(requestParameters: PutSupportEvidenceTypeRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling putSupportEvidenceType.');
        }

        if (requestParameters['supportUpdateEvidenceTypePayload'] === null || requestParameters['supportUpdateEvidenceTypePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateEvidenceTypePayload','Required parameter requestParameters.supportUpdateEvidenceTypePayload was null or undefined when calling putSupportEvidenceType.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/type/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateEvidenceTypePayloadToJSON(requestParameters['supportUpdateEvidenceTypePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update evidence type
     * Update evidence type
     */
    async putSupportEvidenceType(requestParameters: PutSupportEvidenceTypeRequest): Promise<ObjectNoResponse> {
        const response = await this.putSupportEvidenceTypeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async refreshSupportEvidenceRaw(requestParameters: RefreshSupportEvidenceRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling refreshSupportEvidence.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/evidence/{id}/refresh`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     */
    async refreshSupportEvidence(requestParameters: RefreshSupportEvidenceRequest): Promise<ObjectNoResponse> {
        const response = await this.refreshSupportEvidenceRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum GetProviderEvidenceListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderEvidenceListSortEnum {
    CREATED = 'CREATED',
    STATUS = 'STATUS',
    EXPERIMENTID = 'EXPERIMENT_ID',
    PRIMARYPAYERID = 'PRIMARY_PAYER_ID',
    BILLINGPROVIDERID = 'BILLING_PROVIDER_ID',
    RENDERINGPROVIDERID = 'RENDERING_PROVIDER_ID',
    FACILITYID = 'FACILITY_ID',
    EXPIRED = 'EXPIRED'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderEvidenceMissingListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderEvidenceMissingListSortEnum {
    EVIDENCETYPEID = 'EVIDENCE_TYPE_ID'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderEvidenceTypeListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetProviderEvidenceTypeListSortEnum {
    CREATED = 'CREATED'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportEvidenceListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportEvidenceListSortEnum {
    CREATED = 'CREATED',
    STATUS = 'STATUS',
    EXPERIMENTID = 'EXPERIMENT_ID',
    PRIMARYPAYERID = 'PRIMARY_PAYER_ID',
    BILLINGPROVIDERID = 'BILLING_PROVIDER_ID',
    RENDERINGPROVIDERID = 'RENDERING_PROVIDER_ID',
    FACILITYID = 'FACILITY_ID',
    EXPIRED = 'EXPIRED'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportEvidenceMissingListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportEvidenceMissingListSortEnum {
    EVIDENCETYPEID = 'EVIDENCE_TYPE_ID'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportEvidenceTypeListOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum GetSupportEvidenceTypeListSortEnum {
    CREATED = 'CREATED'
}
